document.addEventListener('DOMContentLoaded', function () {

  // ============================================
  // 1. 預載所有 Variant 圖片
  // ============================================
  const productJson = document.querySelector('[data-product-json]');
  if (productJson) {
    try {
      const product = JSON.parse(productJson.textContent);
      product.images.forEach(function (imgUrl) {
        const img = new Image();
        img.src = imgUrl;
      });
    } catch (e) {
      console.warn('圖片預載失敗:', e);
    }
  }

  // ============================================
  // 2. 判斷版本並取得正確容器
  // ============================================
  function isDesktop() {
    return !!document.querySelector('media-gallery .media-gallery__grid');
  }

  function getFirstMediaContainer() {
    if (isDesktop()) {
      // 桌面版：media-gallery 內第一個 li
      return document.querySelector('media-gallery .media-gallery__grid .product-media-container');
    } else {
      // 行動版：找第一個非隱藏的 slideshow-slide
      const slides = document.querySelectorAll('slideshow-slide.product-media-container');
      for (let i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('aria-hidden') !== 'true') {
          return slides[i];
        }
      }
      // 備用
      return document.querySelector('slideshow-slide.product-media-container');
    }
  }

  function getLoaderWrapper() {
    if (isDesktop()) {
      return document.querySelector('media-gallery');
    } else {
      const slide = getFirstMediaContainer();
      return slide ? slide.parentElement : null;
    }
  }

  // ============================================
  // 3. Loader 控制
  // ============================================
  let loaderTimeout = null;

  function showLoader() {
    const wrapper = getLoaderWrapper();
    if (!wrapper) return;

    let loader = document.getElementById('variant-loader');
    if (!loader) {
      loader = document.createElement('div');
      loader.id = 'variant-loader';
      loader.innerHTML = '<div class="variant-spinner"></div>';
      wrapper.style.position = 'relative';
      wrapper.appendChild(loader);
    }
    loader.style.display = 'flex';

    if (loaderTimeout) clearTimeout(loaderTimeout);
    loaderTimeout = setTimeout(hideLoaderAndShowLabel, 6000);
  }

  function hideLoaderAndShowLabel() {
    if (loaderTimeout) { clearTimeout(loaderTimeout); loaderTimeout = null; }
    const loader = document.getElementById('variant-loader');
    if (loader) loader.style.display = 'none';
    renderLabel();
  }

  // ============================================
  // 4. 等新圖片載入完成
  // ============================================
  function waitForNewImageLoad() {
    setTimeout(function () {
      const container = getFirstMediaContainer();
      const img = container ? container.querySelector('.product-media__image') : null;

      if (!img) { hideLoaderAndShowLabel(); return; }

      if (img.complete && img.naturalWidth > 0) {
        hideLoaderAndShowLabel();
      } else {
        img.addEventListener('load', hideLoaderAndShowLabel, { once: true });
        img.addEventListener('error', hideLoaderAndShowLabel, { once: true });
      }
    }, 500);
  }

  // ============================================
  // 5. Variant 標籤
  // ============================================
  let currentVariantTitle = '';
  let labelReady = false;

  function showVariantLabel(variantTitle) {
    currentVariantTitle = variantTitle;
    labelReady = false;
  }

  function removeAllLabels() {
    document.querySelectorAll('.variant-label-tag').forEach(function (el) {
      el.remove();
    });
  }

  function renderLabel() {
    labelReady = true;
    if (!currentVariantTitle) return;

    removeAllLabels();

    const container = getFirstMediaContainer();
    if (!container) return;

    if (getComputedStyle(container).position === 'static') {
      container.style.position = 'relative';
    }

    const label = document.createElement('div');
    label.className = 'variant-label-tag';
    label.textContent = currentVariantTitle;
    container.appendChild(label);
  }

  // ============================================
  // 6. 行動版：滑動時隱藏標籤
  // ============================================
  function setupMobileSwipeHide() {
    if (isDesktop()) return;

    const slideshowEl = document.querySelector('slideshow-component, [data-slideshow]')
      || document.querySelector('media-gallery');

    const hideLabel = function () {
      document.querySelectorAll('.variant-label-tag').forEach(function (el) {
        el.style.display = 'none';
      });
    };

    if (slideshowEl) {
      slideshowEl.addEventListener('scroll', hideLabel, { passive: true });
      slideshowEl.addEventListener('touchstart', hideLabel, { passive: true });
    }

    // 備用：監聽 slideshow-slide 的點擊/滑動
    document.addEventListener('touchstart', function (e) {
      if (e.target.closest('slideshow-slide') && !e.target.closest('.combined-variant-btn')) {
        hideLabel();
      }
    }, { passive: true });
  }

  // ============================================
  // 7. MutationObserver 防止標籤被移除
  // ============================================
  const observer = new MutationObserver(function () {
    if (labelReady && currentVariantTitle && !document.querySelector('.variant-label-tag')) {
      renderLabel();
    }
  });

  const productSection = document.querySelector('.product, [data-section-type="product"], main');
  if (productSection) {
    observer.observe(productSection, { childList: true, subtree: true });
  }

  // ============================================
  // 8. 監聽 Variant 切換
  // ============================================
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.combined-variant-btn');
    if (btn) {
      removeAllLabels();
      labelReady = false;
      showVariantLabel(btn.textContent.trim());
      showLoader();
      waitForNewImageLoad();
    }
  });

  // ============================================
  // 9. 頁面載入時顯示預設 Variant 名稱
  // ============================================
  const activeBtn = document.querySelector(
    '.combined-variant-btn[aria-pressed="true"], .combined-variant-btn.active, .combined-variant-btn.is-selected'
  );
  if (activeBtn) {
    currentVariantTitle = activeBtn.textContent.trim();
  } else {
    const firstBtn = document.querySelector('.combined-variant-btn');
    if (firstBtn) currentVariantTitle = firstBtn.textContent.trim();
  }

  labelReady = true;
  renderLabel();
  setupMobileSwipeHide();

});
